import { Controller } from "@hotwired/stimulus"

// Live URL preview as the seller types a store name.
// data values: fallback (e.g. "elias-glyptis"), shortId ("5cd569"), host ("trofika.com"), localePrefix ("" or "/en")
export default class extends Controller {
  static targets = ["input", "url"]
  static values = {
    fallback: String,
    shortId: String,
    host: String,
    localePrefix: String,
  }

  connect() {
    this.update()
  }

  update() {
    const raw = (this.inputTarget.value || "").trim()
    const slug = this.slugify(raw) || this.fallbackValue || "farmer"
    const prefix = this.localePrefixValue || ""
    this.urlTarget.textContent = `${this.hostValue}${prefix}/farmers/${slug}-${this.shortIdValue}`
  }

  // Basic ASCII parameterize. Greek/Thai/Russian chars get stripped — matches
  // Ruby's default String#parameterize behavior (no transliteration).
  slugify(s) {
    return s
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-")
  }
}
